import * as React from 'react';

const WalletSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="wallet_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 48 48"
        xmlSpace="preserve"
        {...props}
    >
        <style>{'\n        .wallet_svg__st0{fill:#1d0a32}\n    '}</style>
        <path
            className="wallet_svg__st0"
            d="M47.9 20.6l-8-20c-.1-.3-.3-.5-.6-.6-.3 0-.6 0-.8.1-8.6 5-13.1 6.5-17.7 8s-9.3 3.1-18.2 8c-.4.2-.6.8-.4 1.2.5 1.3 1 2.4 1.3 3.3l.5 1.6V47c0 .6.4 1 1 1h38c.6 0 1-.4 1-1V23.7c1.1-.6 2.3-1.2 3.5-1.8.4-.3.6-.8.4-1.3zM42 32v5h-6.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5H42zm-3 14v-7h3v7h-3zm3-16h-3v-4c1-.4 2-.9 3-1.4V30zm-3-6.2V22c0-.6-.4-1-1-1h-9.1c.1-.3.1-.7.1-1 0-2.8-2.2-5-5-5s-5 2.2-5 5c0 .3 0 .7.1 1H16c-.6 0-1 .4-1 1s.4 1 1 1h21v7h-1.5C33 30 31 32 31 34.5s2 4.5 4.5 4.5H37v7H6V23h4c.6 0 1-.4 1-1s-.4-1-1-1H5.7l-.4-1c-.3-.7-.6-1.5-1-2.5 8.3-4.5 12.8-6 17.1-7.5 4.6-1.5 9-2.9 17.1-7.6l7.2 18.1c-2.3 1.3-4.6 2.4-6.7 3.3zM21.2 21c-.1-.3-.2-.6-.2-1 0-1.7 1.3-3 3-3s3 1.3 3 3c0 .4-.1.7-.2 1h-5.6z"
        />
        <path
            className="wallet_svg__st0"
            d="M34 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
        />
    </svg>
);

WalletSvg.displayName = 'WalletSvg';
export default WalletSvg;
